import { render, staticRenderFns } from "./modalRegistrarPago.vue?vue&type=template&id=0ea33548&"
import script from "./modalRegistrarPago.vue?vue&type=script&lang=js&"
export * from "./modalRegistrarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports